<template>
  <div>
    <h1>Holiday conflicts</h1>
    <p>Below are listed the conflicts on this calendar. Here you can delete any conflicts which are no longer needed</p>
    <v-data-table
      :headers="headers"
      :items="computedConflicts"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <HolidayEntity :entity="props.item.entity" format="index" v-if="props.item.entity" />
          </td>
          <td>
            <HolidayEntity :entity="props.item.conflict" format="index" v-if="props.item.conflict" />
          </td>
          <td>
            <EntityZ :entity="props.item.user" format="system" v-if="props.item.user" />
          </td>
          <td>{{props.item.timestamp | formatDateTime}}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteConflict(props.item)"
                  v-if="$keycloak.hasRealmRole('holidayadmin')"
                  small
                  color="error"
                  v-on="on"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Delete this conflict</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <template v-if="$keycloak.hasRealmRole('holidayadmin')">
      <br />
      <hr />
      <h2>Create new conflict</h2>
      <v-select
        label="Between"
        v-model="entityId"
        :items="entities"
        item-value="id"
        outline
        v-if="entities"
      >
        <template slot="selection" slot-scope="data">{{ nameFormatted(data.item) }}</template>
        <template slot="item" slot-scope="data">{{ nameFormatted(data.item) }}</template>
      </v-select>
      <v-select
        label="And"
        v-model="conflictId"
        :items="computedEntities"
        item-value="id"
        outline
        v-if="entityId"
      >
        <template slot="selection" slot-scope="data">{{ nameFormatted(data.item) }}</template>
        <template slot="item" slot-scope="data">{{ nameFormatted(data.item) }}</template>
      </v-select>
      <v-btn @click="createConflict" :disabled="!entityId || !conflictId">
        <v-icon>save</v-icon>Save
      </v-btn>
    </template>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import HolidayEntity from "@/components/link/HolidayEntity";
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "HolidayConflicts",
  metaInfo() {
    return {
      title: "Holiday conflicts",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, HolidayEntity },
  computed: {
    computedConflicts() {
      if (!this.conflicts) {
        return undefined;
      }
      return this.conflicts.map(c => {
        const entity = this.conflictsEntities
          ? this.conflictsEntities[c.id]
          : undefined;
        const conflict = this.conflictsConflicts
          ? this.conflictsConflicts[c.id]
          : undefined;
        const user = this.conflictsUsers
          ? this.conflictsUsers[c.id]
          : undefined;
        return { ...c, entity, conflict, user };
      });
    },
    computedEntities() {
      if (!this.entities || !this.entityId) {
        return undefined;
      }
      return this.entities.filter(e => {
        return e.id != this.entityId;
      });
    }
  },
  data() {
    return {
      entities: null,
      conflicts: null,
      conflictsEntities: null,
      conflictsConflicts: null,
      conflictsUsers: null,
      entityId: null,
      conflictId: null,
      headers: [
        {
          text: "between",
          value: "entity.name"
        },
        {
          text: "and",
          value: "conflict.name"
        },
        {
          text: "created by",
          value: "user.name"
        },
        {
          text: "created on",
          value: "timestamp"
        },
        {
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/directory/types/2/entities`)
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        })
        .catch(() => {});
    },
    fetchConflicts() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/conflicts`)
        .then(response => {
          // console.log(response.data);
          this.conflicts = response.data;
        })
        .catch(() => {});
    },
    fetchConflictsEntities() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/conflicts/entities`)
        .then(response => {
          // console.log(response.data);
          this.conflictsEntities = response.data;
        })
        .catch(() => {});
    },
    fetchConflictsConflicts() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/conflicts/conflicts`)
        .then(response => {
          // console.log(response.data);
          this.conflictsConflicts = response.data;
        })
        .catch(() => {});
    },
    fetchConflictsUsers() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/conflicts/users`)
        .then(response => {
          // console.log(response.data);
          this.conflictsUsers = response.data;
        })
        .catch(() => {});
    },
    deleteConflict(conflict) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/directory/holidays/conflicts/${conflict.id}`)
          .then(() => {
            // console.log(response.data);
            this.update();
          })
          .catch(() => {});
      }
    },
    nameFormatted(entity) {
      return nameFormatted(entity.name, "index");
    },
    createConflict() {
      nbmlaw
        .post(
          `/cors/admin/directory/entities/${this.entityId}/conflicts/${this.conflictId}`,
          null
        )
        .then(() => {
          // console.log(response.data);
          this.update();
          this.entityId = null;
          this.conflictId = null;
        })
        .catch(() => {});
    },
    update() {
      this.fetchEntities();
      this.fetchConflicts();
      this.fetchConflictsEntities();
      this.fetchConflictsConflicts();
      this.fetchConflictsUsers();
    }
  },
  created() {
    this.update();
  }
};
</script>
